<template>
  <div class="container">
    <!--预览-->
    <div class="goback1">
      <div class="goBtn">
        <van-nav-bar title="原始报告" left-arrow @click-left="goBack" />
      </div>
    </div>
    <div class="pdfbox">
      <div id="demo"></div>
    </div>
  </div>
</template>

<script>

import { GetFileServiceUrl, GetGoBackUrlParms } from '../../utils/cacheUtils'
import Pdfh5 from 'pdfh5';
export default {
  data() {
    return {
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: 'pdf', // 文件类型
      pdfSrc: '',
      pdfh5: null
    }
  },
  methods: {
    // 返回上级
    goBack() {
      this.$router.push({ path: '/reportView?' + GetGoBackUrlParms() })
    },
    async Init() {
      const fileServiceUrl = await GetFileServiceUrl()
      this.pdfh5 = new Pdfh5('#demo', {
        pdfurl: fileServiceUrl + this.$route.query.path + '?'+ new Date().getTime(),
        scrollEnable: true, //是否允许pdf滚动
        zoomEnable: true, //是否允许pdf手势缩放
        renderType: 'canvas', //pdf渲染模式 svg canvas
      });
      this.pdfh5.on("complete", function (status, msg, time) {
        // this.zoomEnable(false);
        console.log("状态：" + status + "，信息：" + msg + "，耗时：" + time + "毫秒，总页数：" + this.totalNum)
      })
    }
  },
  activated() {
    this.Init()
    // 禁止页面滚动
    function preventDefault(e) {
      e.preventDefault();
    }

    // Chrome 51、Firefox 49及以上
    // 禁用触摸滚动页面
    document.getElementsByClassName('container')[0].addEventListener('touchmove', preventDefault, { passive: false });
    // 恢复触摸滚动页面
    // document.removeEventListener('touchmove', preventDefault, {passive: false});


    // Chrome 51、 Firefox 49以下
    document.getElementsByClassName('container')[0].addEventListener('touchmove', preventDefault, false);
    // document.removeEventListener('touchmove', preventDefault, false);
    //监听完成事件
  }


  //   },
}
</script>
<style>
@import '../../../public/static/pdfh5.css';

</style>
<style scoped>

* {
  padding: 0;
  margin: 0;
}

body:before {
  width: 100%;
  height: 100%;
  content: ' ';
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  background: #fff;
}
/* 
html,
body,
#app {
  width: 100%;
  height: 100%;
} */

.container {
  height: 100%;
}

.pdfbox {
  height: calc(100% - 50px);
}

/* 限定放大hidden范围 */
.pdfbox {
  overflow: hidden;
  padding: 0.2rem;
  box-sizing: border-box;
}
</style>